import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b76644be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkout-payment-method" }

import { watch } from 'vue';
import CheckoutItems from '@/components/checkout/CheckoutItems.vue';
import PayWithCardButton from '@/components/checkout/PayWithCardButton.vue';
import PayWithEthButton from '@/components/checkout/PayWithEthButton.vue';
import NumberToPurchaseInput from '@/components/NumberToPurchaseInput.vue';
import SpecialNetworkBanner from '@/components/SpecialNetworkBanner.vue';
import { useClaimStore } from '@/store/claimStore';

interface ChoosePaymentMethodPageProps {
  onChoseMethod: (method: string) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChoosePaymentMethodPage',
  props: {
    onChoseMethod: { type: Function }
  },
  setup(__props: any) {


const store = useClaimStore();

watch(
  () => store.tokensToPurchase,
  () => {
    store.initializeFiatPrices();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NumberToPurchaseInput),
    _createVNode(CheckoutItems, {
      "show-in-fiat": _unref(store).displayFiatPrice
    }, null, 8, ["show-in-fiat"]),
    _createVNode(SpecialNetworkBanner, { class: "checkout-network" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PayWithEthButton, {
        onClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChoseMethod('eth')))
      }),
      _createVNode(PayWithCardButton, {
        class: _normalizeClass(_unref(store).displayFiatPrice ? 'display-first' : ''),
        onClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChoseMethod('card')))
      }, null, 8, ["class"])
    ])
  ], 64))
}
}

})